import app from "./appInstance";
import "./admin-panel/main";
import "./app/main";

window.Vue = app;
Vue.config.globalProperties._t = window._t;
window.Event = app;

if (document.getElementById("app")) app.mount("#app");
